export enum TaxEnum {
    Inclusive = 'Incluye',
    Exclusive = 'Excluye'
}
